import React from 'react';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import {connect} from 'react-redux'
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Typography from "@mui/material/Typography";
import {useTranslation} from 'react-i18next';
import {deleteSeat} from "../../../../../store/actions/planner/SeatAction";
import Button from "../../../inputs/Button";

const DeleteDialog = ({open, setOpen, onDeleted, deleting, seat, deleteSeat}) => {
    const {t} = useTranslation();

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = () => {
        deleteSeat(seat.Planner_Event_Seat__)
            .then(() => {
                handleClose();
                onDeleted();
            })
    };

    return (
        <Dialog
            open={open}
            aria-labelledby={t('confirm_delete_seat_title')}
            aria-describedby={t('confirm_delete_seat_title')}
            fullWidth
        >
            <DialogTitle id="seat-delete-title">{t('confirm_delete_seat_title')}</DialogTitle>
            <DialogContent>
                <DialogContentText id="seat-delete-description">
                    {t('confirm_delete_seat_desc')}
                    <br/>
                    <Typography variant="body1" color="textPrimary" component="span">{t('are_you_sure')}</Typography>
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button variant='contained' color="primary" autoFocus onClick={handleClose} disabled={deleting}>
                    {t('back_btn')}
                </Button>
                <Button color="secondary" disabled={deleting} loading={deleting} endIcon={<DeleteForeverIcon/>} onClick={handleDelete}>
                    {t('delete_btn')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = (state) => {
    return {
        deleting: state.seat.deleting
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        deleteSeat: (id) => dispatch(deleteSeat(id))
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(DeleteDialog);